export default "__VITE_ASSET__B7gz4$8m__"